export const SERVER_URL = process.env.REACT_APP_SERVER_URL;

// Break-glass recovery account. Its self-service "Change password" menu item is
// hidden in the UI so it stays a stable admin-managed fallback login.
export const RECOVERY_USER_EMAIL = 'recovery@bliss.com';


export const CAMPUSES = [
  { value: 'Kilgraston', label: 'Kilgraston' },
  { value: 'Rishworth', label: 'Rishworth' },
  { value: 'StBees', label: 'StBees' },
  { value: 'Strathallan', label: 'Strathallan' },//
    // Add more campuses as needed
  ];

  export const STATUS = [
    { value: 'PROVISIONAL', label: 'PROVISIONAL' },
    { value: 'CONFIRMED', label: 'CONFIRMED' },
    { value: 'PAID', label: 'PAID' },
    ];

    export const ACCOUNTS = [
      { value: 'WISE', label: 'WISE' },
      { value: 'MONZO', label: 'MONZO' },
      { value: 'HSBC', label: 'HSBC' },
    ];
    
    export const ROLES = [
      { value: 'TEACHER', label: 'TEACHER' },
      { value: 'ACTIVITIES', label: 'ACTIVITIES' },
      { value: 'NIGHSHIFT', label: 'NIGHSHIFT' },
    ];

    export const GROUPTYPES = [
      { value: 'ROOM', label: 'ROOM' },
      { value: 'CLASS', label: 'CLASS' },
      { value: 'AFTERNOON', label: 'AFTERNOON' },
      { value: 'EXCURSION', label: 'EXCURSION' },
    ];

    export const SCHEDULETYPE = [
      {value: 'STAFF', label: 'STAFF'},
      {value: 'GROUPS/ROOMS', label: 'GROUPS/ROOMS'},
    ]

    export const CUTOFF_DATE = '2023-08-15';

    export const WEEKS = [
      { week: '1: 30/06/24-06/07/24', startDate: '2024-06-30', endDate: '2024-07-06' },
      { week: '2: 07/07/24-13/07/24', startDate: '2024-07-07', endDate: '2024-07-13' },
      { week: '3: 14/07/24-20/07/24', startDate: '2024-07-14', endDate: '2024-07-20' },
      { week: '4: 21/07/24-27/07/24', startDate: '2024-07-21', endDate: '2024-07-27' },
      { week: '5: 28/07/24-03/08/24', startDate: '2024-07-28', endDate: '2024-08-03' },
      { week: '6: 04/08/24-10/08/24', startDate: '2024-08-04', endDate: '2024-08-10' },
    ];
    

// Which app this is, for the admin sessions list in Greaterbase. The backend
// can infer it from the Origin, but both apps are localhost in development,
// so say it.
export const APP_CLIENT = "locatorbase";
